import styled from 'styled-components';
import {device} from '../../../../utils/utils';
import headerBg from '../../assets/header-bg.png';

export const HeaderCont = styled.div`
  height: 332px;
  background: linear-gradient(180deg, #0b1b29 -68.68%, #554176 114.46%);
  position: relative;
  & img {
    max-width: 100%;
  }
  &::before {
    content: '';
    width: 564px;
    height: 100%;
    background: url(${headerBg}) top right no-repeat;
    position: absolute;
    right: 0;
    top: -50px;
    background-size: cover;
  }
  @media ${device.mobileS} {
    height: 450px;
    overflow: hidden;
    &::before {
      width: 200px;
      height: 240px;
      top: 0;
      right: -80px;
      background-position: top left;
    }
  }
`;

export const HeaderContDtl = styled.div`
  display: flex;
  position: relative;
  width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
  justify-content: space-between;
  @media ${device.mobileS} {
    width: 100%;
    padding: 0 20px;
    padding-top: 50px;
    flex-direction: column;
    margin-top: 20px;
  }
`;
export const HeaderContDtlLeft = styled.div`
  width: 510px;
  flex-shrink: 0;
  @media ${device.mobileS} {
    width: 100%;
  }
  .latoBold {
    font-weight: 900 !important;
  }
`;
export const HeaderContHeading = styled.h2`
  font-size: 44px;
  line-height: 67px;
  font-weight: 900;
  color: #fff;
  @media ${device.mobileS} {
    font-size: 48px;
    line-height: 57px;
  }
`;
export const HeaderContSubHeading = styled.h3`
  font-size: 28px;
  line-height: 29px;
  font-weight: 900;
  color: #fff;
  margin-top: 27px;
  b {
    font-weight: 900;
  }
  @media ${device.mobileS} {
    margin-top: 24px;
  }
`;
export const HeaderContDtlRight = styled.div`
  width: 650px;
  flex-shrink: 0;
  align-self: flex-end;
  @media ${device.mobileS} {
    width: 100%;
    margin-top: 24px;
    align-self: unset;
  }
`;

export const HeaderContDesc = styled.p`
  font-size: 17px;
  line-height: 19px;
  font-weight: 400;
  color: #fff;
  margin-top: 6px;
  //cursor: pointer;
  //text-decoration: underline;
  .bold {
    font-weight: 900;
  }
  @media ${device.mobileS} {
    font-size: 14px;
    line-height: 16px;
  }
`;

export const HeaderContDescDate = styled.p`
  font-size: 14px;
  line-height: 19px;
  font-weight: 400;
  color: #fff;
  margin-top: 6px;
  //cursor: pointer;
  //text-decoration: underline;
  span {
    font-weight: 900;
  }
  @media ${device.mobileS} {
    font-size: 14px;
    line-height: 16px;
  }
`;

export const Hamburger = styled.span`
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: fixed;
  right: 20px;
  top: 20px;
  span {
    width: 16px;
    height: 3px;
    background-color: #fff;
    border-radius: 10px;
    margin-bottom: 2px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
